export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vérification AML"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez une adresse et sélectionnez une blockchain — nous effectuerons un screening rapide."])}
}